export default __webpack_public_path__ + "static/media/Coffee-Maker-Category-Offer.57fa1ac0.png";